/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetMediaExportJobsByIdQueryResponse, GetMediaExportJobsByIdPathParams, GetMediaExportJobsById404 } from "../models/GetMediaExportJobsById";

export function getGetMediaExportJobsByIdUrl(id: GetMediaExportJobsByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/export-jobs/${id}` as const }
  return res
}

/**
 * @description Returns a single export job for the current user. Result includes fileSize only when completed (no storage URL).
 * @summary Get export job by id
 * {@link /export-jobs/:id}
 */
export async function getMediaExportJobsById(id: GetMediaExportJobsByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetMediaExportJobsByIdQueryResponse, ResponseErrorConfig<GetMediaExportJobsById404>, unknown>({ method : "GET", url : getGetMediaExportJobsByIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}